import Button from './Button';
import Space from './Space';

const Results = ({ answers }) => {
    const getResult = () => {
        let religion = 0;
        let relationship = 0;
        let wayoflife = 0;

        answers.forEach((element) => {
            if (element === 0) {
                religion++;
            } else if (element === 1) {
                relationship++;
            } else if (element === 2) {
                wayoflife++;
            }
        });

        const payload = {
            religion: religion,
            relationship: relationship,
            wayoflife: wayoflife,
        };

        fetch('/.netlify/functions/log-results', {
            method: 'POST',
            body: JSON.stringify(payload),
        });

        return payload;
    };
    const results = getResult(answers);

    const numberToPercentage = (number) => {
        const total = results.religion + results.relationship + results.wayoflife;
        const percentage = (number / total) * 100;
        return `${percentage}%`;
    };

    return (
        <div className="content">
            <div className="results-container">
                <Space s={20} />
                <div className="results-title-container">
                    <p className="results-title">Your Results</p>
                </div>

                <div className="results-content">
                    <div className="result-item">
                        <h2>Religion</h2>
                        <h2>{numberToPercentage(results.religion)}</h2>
                    </div>
                    <p className="result-par">
                        Kamu melihat kekristenan sebagai fondasi hidup yang teratur dan penuh nilai. Iman bagimu adalah
                        sistem kepercayaan yang memberi struktur, batasan moral, dan pedoman hidup. Seperti peta dalam
                        perjalanan, kekristenan membantumu membedakan mana yang benar dan salah, memberi ketenangan
                        lewat aturan yang jelas. Namun, kadang kamu bisa terlalu “tradisional” hingga melupakan esensi
                        di baliknya.
                    </p>
                    <div className="result-item">
                        <h2>Relationship</h2>
                        <h2>{numberToPercentage(results.relationship)}</h2>
                    </div>
                    <p className="result-par">
                        Bagi kamu, kekristenan bukan sekadar agama—ini adalah relasi yang hidup dan dinamis dengan
                        Tuhan. Kamu melihat Allah bukan sebagai sosok jauh di langit, tapi sebagai Bapa, Sahabat, dan
                        Penuntun yang hadir dalam setiap momen hidupmu. Doa adalah percakapan dua arah, bukan rutinitas.
                        Imanmu bertumbuh bukan karena aturan, tapi karena kasih dan keintiman. Kamu menghargai hubungan
                        yang otentik dan mengalami Tuhan dalam keseharian—bukan hanya di gereja. Tapi kadang, karena
                        terlalu fokus pada esensi, kamu bisa melupakan pentingnya disiplin rohani yang membangun.
                    </p>
                    <div className="result-item">
                        <h2>Way of Life</h2>
                        <h2>{numberToPercentage(results.wayoflife)}</h2>
                    </div>
                    <p className="result-par">
                        Imanmu bukan hanya bagian dari hidupmu—iman adalah inti dari siapa dirimu. Kekristenan bukan
                        sekadar kepercayaan, tapi lensa yang membentuk cara berpikir, berbicara, dan bertindak. Kamu
                        berusaha mencerminkan kasih Kristus dalam keputusan, interaksi, dan tujuan hidupmu. Imanmu tidak
                        dibatasi oleh hari Minggu atau aktivitas rohani; ia menyatu dalam pekerjaan, hubungan, dan cara
                        kamu menghadapi tantangan. Ini adalah hidup yang otentik, ketika relasi dengan Tuhan menyatu
                        dengan kedisiplinan rohani. Bahkan nama paling awal dari kekristenan adalah “The Way”—jalan
                        hidup yang mencerminkan Yesus.
                    </p>
                </div>
                <Space s={40} />
                <p>Watch Ps. Raguel's full sermon on spiritual depth</p>
                <iframe
                    width="300"
                    height="200"
                    className="video-embed"
                    src="https://www.youtube.com/embed/0N4dVERG3RI"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                ></iframe>

                <Space s={40} />
                <div className="button-container">
                    <Button label="Take the test again" onClick={() => window.location.reload()} />
                    <p>New Wine International Church</p>
                </div>
                <Space s={80} />
            </div>
        </div>
    );
};

export default Results;
